import React from "react";
import useTheme from "../../hooks/useTheme";
import { ThemeInterface } from "../../services/exports/Interfaces";

interface Props {
  className?: string;
  style?: Object;
  color?: string;
}

export default function CallPickIllustration(props: Props) {
  const { className, color, style } = props;
  const theme: ThemeInterface = useTheme();
  return (
    <svg
      className={className ?? "lg:h-40 lg:w-40 md:w-36 md:h-36 w-24 h-24"}
      viewBox="0 0 422 422"
      fill="none"
      style={style}
    >
      <path
        d="M276.501 414.051C272.201 414.051 268.715 410.565 268.715 406.265C268.715 401.964 272.201 398.479 276.501 398.479C280.801 398.479 284.287 401.964 284.287 406.265C284.287 410.565 280.801 414.051 276.501 414.051Z"
        fill="#E1E4E5"
      />
      <path
        d="M129.773 287.307C124.518 287.307 120.257 283.047 120.257 277.791C120.257 272.536 124.518 268.275 129.773 268.275C135.029 268.275 139.289 272.536 139.289 277.791C139.289 283.047 135.029 287.307 129.773 287.307Z"
        fill="#E1E4E5"
      />
      <path
        d="M348.279 325.797C343.45 325.797 339.535 322.664 339.535 318.801C339.535 314.937 343.45 311.805 348.279 311.805C353.108 311.805 357.023 314.937 357.023 318.801C357.023 322.664 353.108 325.797 348.279 325.797Z"
        fill="#E1E4E5"
      />
      <path
        d="M312.744 217.961C372.808 217.961 421.5 169.27 421.5 109.205C421.5 49.1409 372.808 0.449219 312.744 0.449219C252.68 0.449219 203.988 49.1409 203.988 109.205C203.988 169.27 252.68 217.961 312.744 217.961Z"
        fill={color ?? theme.color.companyBrand.primary}
      />
      <path
        d="M356.454 116.457H312.952V43.9531"
        stroke="white"
        strokeWidth="21.14"
        strokeLinejoin="round"
      />
      <path
        d="M10.1422 116.99C4.06515 94.1131 22.2962 72.9531 45.9672 72.9531H97.0362C106.232 72.9531 114.1 79.4451 116.285 88.3771C122.133 112.283 130.145 134.902 141.099 156.226C145.83 165.435 143.336 176.915 134.722 182.658L120.552 192.105C116.241 194.978 114.956 200.754 117.733 205.127C145.103 248.245 173.705 276.846 216.822 304.217C221.196 306.993 226.971 305.708 229.845 301.398L239.292 287.227C245.034 278.613 256.515 276.119 265.723 280.85C287.047 291.805 309.665 299.816 333.572 305.664C342.504 307.849 348.996 315.718 348.996 324.913V375.982C348.996 399.653 327.837 417.885 304.959 411.807C161.362 373.66 48.2902 260.587 10.1422 116.99V116.99Z"
        fill={color ?? theme.color.companyBrand.primary}
        stroke={color ?? theme.color.companyBrand.primary}
        strokeWidth="16"
      />
    </svg>
  );
}
